import React, { Component } from "react";
import DocumentTitle from "react-document-title";
import Cta from "../Cta";

import { posts } from "./posts";

import style from "./style.sass";

class Blog extends Component {
  render() {
    return (
      <div>
        <DocumentTitle title="Blog" />
        <div styleName="banner" />
        <section className="bg-white" styleName="blog-section">
          <div className="landing-container" styleName="container">
            {posts.map((el, idx) => {
              const index = posts.length - 1 - idx;
              const post = posts[index];
              return (
                <article styleName="post-block" key={index}>
                  <div styleName="post-overview">
                    <a href={"blog/post/" + index}>
                      <h2 styleName="post-header">{post.title}</h2>
                    </a>
                    <div styleName="post-description">
                      {/* <p styleName='post-date'>{post.at}</p> */}
                      <p styleName="author-name"> {post.author}</p>
                    </div>
                    <p styleName="post-content">{post.preview}</p>
                  </div>
                  <a
                    href={"/blog/details/" + index}
                    styleName="post-image-container"
                  >
                    <img src={post.img} styleName="blog-image" />
                  </a>
                </article>
              );
            })}
          </div>
        </section>
        <Cta />
      </div>
    );
  }
}

export default Blog;
